import { defineComponent as _defineComponent } from 'vue'
import { twMerge } from 'tailwind-merge'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Popover',
  props: {
    contentClass: null
  },
  setup(__props: any) {

const props = __props as { contentClass?: string };


const contentClass = computed(() =>
  twMerge(
    'bg-white ring-1 ring-black ring-opacity-5 rounded-md shadow-lg mt-1',
    props.contentClass,
  ),
)

return { __sfc: true,props, contentClass }
}

})